const colorRegex = /^((transparent)|(#[a-fA-F0-9]{3})|(#[a-f0-9]{6})|(rgb\([ 0-9]+,[ 0-9]+,[ 0-9]+\))|(rgba\([ 0-9]+,[ 0-9]+,[ 0-9]+,[ .0-9]+\)))$/i;
export function isValidColor(color){
  if (!color) return false
  return colorRegex.test(color)
}

export function formatField(name)
{
  return name.toUpperCase().replace(/[.*?_]/g, ' ');
}


// WEBPACK FOOTER //
// ./src/utils/index.js